import { formatPrismicData } from '@monofront/business/utils';
import { IFrequentlyBoughtProductsCarousel } from './FrequentlyBoughtProductsCarousel';

export const mapFrequentlyBoughtProductsCarousel = ({
  prismicContent,
  position,
}) => {
  const { primary }: IFrequentlyBoughtProductsCarousel =
    formatPrismicData(prismicContent);

  return {
    primary,
    position,
  };
};
